<div class="d-flex align-items-center justify-content-center">
    <div class="modal-container2 row ml-0 modal-md">


        <div class="modal-container-header col-12">
            <span>{{ 'labels.vehiculo' | translate}}</span>
            <span class="k-icon k-i-close" (click)="closeModal('modalEsa',false)"></span>
        </div>


        <div class="modal-container-section col-12">

            <form [formGroup]="formEsa">
                <div class="ownerBox">
                    <h2>{{ 'taller.recepcion_vehiculo.buscarVehiculo' | translate }}</h2>
                    <div class="row">
                        <label
                            class="col-sm-3 col-form-label">{{ 'taller.recepcion_vehiculo.Matricula' | translate }}</label>
                        <div class="col-sm-8">
                            <input type="text" formControlName="Plate" class="form-control form-control-sm"
                                [ngClass]="{'form-error': formEsa.controls.Plate.invalid}">
                        </div>
                        <div class="col-sm-1">
                            <span class="k-icon k-i-close" *ngIf="formEsa.controls.PlateCheck.value"></span>
                        </div>
                    </div>
                    <div class="row">
                        <label class="col-sm-3 col-form-label">{{ 'labels.vin' | translate }}</label>
                        <div class="col-sm-8">
                            <input type="text" formControlName="Vin" class="form-control form-control-sm">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <label
                        class="col-sm-4 col-form-label">{{ 'taller.recepcion_vehiculo.BRANDCODE' | translate }}</label>
                    <div class="col-sm-7">
                        <kendo-dropdownlist formControlName="Model" [data]="GetAllVehicles" [textField]="'Description'"
                            [valueField]="'BrandCode'" [ngClass]="{'form-error': formEsa.controls.Model.invalid}"
                            class="form-control float-right">
                            <ng-template kendoDropDownListItemTemplate let-dataItem>
                                <span class="kendo_list_template">{{ dataItem.Description }}</span>
                            </ng-template>
                        </kendo-dropdownlist>
                    </div>
                    <div class="col-sm-1">
                        <span class="k-icon k-i-close" *ngIf="formEsa.controls.ModelCheck.value"></span>
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-4 col-form-label">Descripción modelo</label>
                    <div class="col-sm-7">
                        <input formControlName="Description" type="text"
                            [ngClass]="{'form-error': formEsa.controls.Description.invalid}"
                            class="form-control float-right">
                    </div>
                    <div class="col-sm-1">
                        <span class="k-icon k-i-close" *ngIf="formEsa.controls.DescriptionCheck.value"></span>
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-4 col-form-label">Fecha matriculación</label>
                    <div class="col-sm-7">
                        <calendario [showButtonBar]="false" class="calendario" [formulario]="formEsa"
                            [controlName]="'PlateRegistrationDate'">
                        </calendario>
                    </div>
                    <div class="col-sm-1">
                        <span class="k-icon k-i-close" *ngIf="formEsa.controls.PlateRegistrationDateCheck.value"></span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-7">
                        <p *ngIf="hasChanges"><strong>¿Deseas actualizar los campos seleccionados?</strong></p>
                    </div>
                </div>

                <div class="modal-container-buttons">
                    <div class="d-flex align-content-end justify-content-center">
                        <button class="btn-steps mr-2" type="button" (click)="updateESA()"
                            [attr.disabled]="(formEsa.valid && formEsa.dirty) ? null : true">
                            {{ 'labels.aceptar' | translate}}
                            <span class="k-icon k-i-arrow-60-right  color_blue text-size-big"></span>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
